import { useState, forwardRef,  useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';
import SeccionPageHeader from '../Utils/SeccionPageHeader.jsx';
import apiService from '../../Auth/apiService.jsx';
import SweetAlert2 from 'react-sweetalert2';
import { useAuth } from '../../Auth/AuthContext.jsx';
import CargandoSpinner from '../Utils/CargandoSpinner.jsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendar } from 'react-icons/fa';
import Select from 'react-select';

const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            border: 'none',
            background: 'none',
            padding: 0,
            width: '100%'
        }}
    >
        <input
            value={value}
            readOnly
            className='widthCalendar'
            tabIndex={-1}
            style={{
                pointerEvents: 'none',
                background: '#fff',
                borderRadius: 4,
                flex: 1,
                minWidth: 0
            }}
        />
        <FaCalendar style={{ marginLeft: 8, color: '#495057', flex: '0 0 auto' }} />
    </button>
));

export default function FormularioOrganizacion(){
    const Navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const { token, user, rol } = useAuth();
    const { id } = useParams();
    const { control, handleSubmit, register, setValue, getValues, watch, reset, formState: { errors }} = useForm({
        defaultValues: {
            gruposPoblacion: [],
            fuentesFinancieras: [],
            orgUserid: user || '',
            orgConstitucionLegal: null,
            orgTienesede: null,
            orgTieneplantrabajo: null,
        }
    });
    const [swalProps, setSwalProps] = useState({});
    const [comunas, setComunas] = useState([]);
    const [comunasLoaded, setComunasLoaded] = useState(false);
    const [gruposPoblaciones, setGruposPoblaciones] = useState([]);
    const [fuentesFinancieras, setFuentesFinancieras] = useState([]);
    const [gruposPoblacionSelected, setGruposPoblacionSelected] = useState([]);
    const [fuentesFinancierasSelected, setFuentesFinancierasSelected] = useState([]);
    const [initialOrganizacion, setInitialOrganizacion] = useState(null);
    const ActualizarGruposPoblacion  = grupo => {
        setGruposPoblacionSelected(grupo);
    };
    const ActualizarFuenteFinancieras  = fuente => {
        setFuentesFinancierasSelected(fuente);
    }
    const resetForm = useCallback((data) => {
        // store orgConstitucionLegal as 'SI' / 'NO' for the select
        const constitucion = (typeof data?.orgConstitucionLegal === 'boolean')
            ? (data.orgConstitucionLegal ? 'SI' : 'NO')
            : (data?.orgConstitucionLegal ?? 'NO');
        // normalize orgTienesede as 'SI' / 'NO' for the select
        const tieneSede = (typeof data?.orgTienesede === 'boolean')
            ? (data.orgTienesede ? 'SI' : 'NO')
            : (data?.orgTienesede ?? 'NO');

        const tienePlanTrabajo = (typeof data?.orgTieneplantrabajo === 'boolean')
            ? (data.orgTieneplantrabajo ? 'SI' : 'NO')
            : (data?.orgTieneplantrabajo ?? 'NO');
        reset((prevValues) => ({
            ...prevValues,
            id: data?.id || '0',
            orgNombre: data?.orgNombre || '',
            orgCorreo: data?.orgCorreo || '',
            orgTelefono: data?.orgTelefono || '',
            orgDireccion: data?.orgDireccion || '',
            orgComuna: data?.orgComuna || '',
            orgConstitucionLegal: constitucion,
            orgTienesede: tieneSede,
            orgNombrerepresentante: data?.orgNombrerepresentante || '',
            orgTotalintegrantes: data?.orgTotalintegrantes != null ? Number(data.orgTotalintegrantes) : '',
            orgTotalintegrantevictima: data?.orgTotalintegrantevictima != null ? Number(data.orgTotalintegrantevictima) : '',
            orgUserid: data?.orgUserid || '',
            orgFechaactualizacion: data?.orgFechaactualizacion ? new Date(data.orgFechaactualizacion) : null,
            orgObservaciones: data?.orgObservaciones || '',
            orgNit: data?.orgNit || '',
            orgTematica: data?.orgTematica || '',
            orgTieneplantrabajo: tienePlanTrabajo,
        }));
    }, [reset]);

    const fetchData = useCallback(async (id, rol, user) => {
        const url = '/organizaciones/crearformularioorganizaciones';
        const obj = {id: id, usrRolid: rol, userId: user};
        setCargando(true);
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            const grupopoblacional = result.grupospoblaciones.map((g) => ({value: g.id, label: `${g.gruGrupopoblacion}`}));
            setGruposPoblaciones(grupopoblacional);
            const fuentesfinancieras = result.fuentefinancieras.map((f) => ({value: f.id, label: `${f.fueFuente}`}));
            setFuentesFinancieras(fuentesfinancieras);
            setComunas(result.comunas || []);
            setComunasLoaded(true);
            setInitialOrganizacion(result.organizacion || null);
            setGruposPoblacionSelected(grupopoblacional.filter(g => 
                result.grupopoblacionalorg?.some(og => og.relGrupopoblacionid === g.value)
            ));
            setFuentesFinancierasSelected(fuentesfinancieras.filter(f => 
                result.fuentefinancieraorg?.some(of => of.relFuentefinancieraid === f.value)
            ));
        })
        .catch(error => {
            Mensaje('Crear formulario', `Hubo un error con la carga de datos de la organicacion nro ${id}: ${error}`);
        })
        .finally(() => {
            setCargando(false);
            setValue('id', id);
        });
    }, [token, setValue]);

    useEffect(() => {
        if (initialOrganizacion && comunasLoaded) {
            resetForm(initialOrganizacion);
            setInitialOrganizacion(null);
            setComunasLoaded(false);
        }
    }, [initialOrganizacion, comunasLoaded, resetForm]);
    
    useEffect(() => {
        fetchData(id, rol, user)
    }, [fetchData, id, rol, user]);
   
        
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/organizaciones/guardarorganizacion';
        data.orgConstitucionLegal = data.orgConstitucionLegal === 'SI' ? true : false;
        data.orgTienesede = data.orgTienesede === 'SI' ? true : false;
        data.orgTieneplantrabajo = data.orgTieneplantrabajo === 'SI' ? true : false;
        data.gruposPoblacion = gruposPoblacionSelected.map(g => ({grupoId: g.value}));
        data.fuentesFinancieras = fuentesFinancierasSelected.map(f => ({fuenteId: f.value}));
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Registrar atencion', JSON.stringify('Se guardo el formulario con exito: ' + response.data.organizacion.id));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Formulario organizaciones" idCabezaFamilia={'1'} url={'/organizaciones/listar'} nombreurl="Organizaciones" nombreform="Formulario" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-info">
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <input hidden {...register('usrId')} />
                                    <input hidden {...register('id')} />                                    
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor='orgNombre'>NOMBRE DE LA ORGANIZACI&Oacute;N</label>
                                                <input id='orgNombre' {...register('orgNombre', { required: true })} className="form-control" placeholder="Org nombre" />
                                                {errors.orgNombre && <small className="text-danger">El nombre de la organizaci&oacute;n es obligatorio</small>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor='orgCorreo'>CORREO ELECTRONICO</label>
                                                <input id='orgCorreo' {...register('orgCorreo')} type="email" className="form-control" placeholder="correo@ejemplo.com" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor='orgTelefono'>TEL&Eacute;FONO</label>
                                                <input id='orgTelefono' {...register('orgTelefono')} className="form-control" placeholder="Telefono" />
                                            </div>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="form-group">
                                                <label htmlFor='orgDireccion' >DIRECCI&Oacute;N</label>
                                                <input id='orgDireccion' {...register('orgDireccion')} className="form-control" placeholder="Dirección" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor='orgComuna'>COMUNA</label>
                                                <select id='orgComuna' 
                                                    {...register('orgComuna' , { required: true })} 
                                                    className="form-control"
                                                    >
                                                    <option value="">Seleccione comuna</option>
                                                    {comunas.map((c) => (
                                                        <option
                                                            key={c.id}
                                                            value={c.id}
                                                        >
                                                            {c.comComuna}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.orgComuna && <small className="text-danger">Seleccione comuna</small>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor='orgConstitucionLegal'>¿ESTA CONSTITUIDA LEGALMENTE?</label>
                                                <select 
                                                    id='orgConstitucionLegal' 
                                                    {...register('orgConstitucionLegal', { required: true })} 
                                                    onClick={(e) => {
                                                        setValue('orgConstitucionLegal', e.target.value);
                                                        setValue('orgNit', '');
                                                    }}
                                                    className="form-control">
                                                    <option value=""></option> 
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.orgConstitucionLegal && <p style={{ color: 'red' }}>Seleccione una opción</p>}
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <label htmlFor='orgNit'>NIT (solo aplica si está constituida legalmente)</label>
                                                <input 
                                                    id='orgNit' 
                                                    disabled={watch('orgConstitucionLegal') !== 'SI'}
                                                    {...register('orgNit', {required: watch('orgConstitucionLegal') === 'SI' ? true : false})} 
                                                    className="form-control" />
                                                {errors.orgNit && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor='orgTienesede'>¿TIENE SEDE?</label>
                                                <select id='orgTienesede' {...register('orgTienesede', {required: true})} className="form-control">
                                                    <option value=""></option> 
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.orgTienesede && <p style={{ color: 'red' }}>Seleccione una opción</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor='orgNombrerepresentante'>NOMBRE DEL REPRESENTANTE DE LA ORGANIZACI&Oacute;N</label>
                                                <input id='orgNombrerepresentante' {...register('orgNombrerepresentante', {required: true})} className="form-control" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor='orgTotalintegrantes'>N&Uacute;MERO TOTAL DE INTEGRANTES</label>
                                                <input
                                                    id='orgTotalintegrantes'
                                                    type="number"
                                                    min="0"
                                                    step="1"
                                                    {...register('orgTotalintegrantes', { required: true, valueAsNumber: true })}
                                                    className="form-control"
                                                />
                                                {errors.orgTotalintegrantes && <p style={{ color: 'red' }}>Este campo es obligatorio</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor='orgTotalintegrantevictima'>N&Uacute;MERO DE INTEGRANTES V&Iacute;CTIMAS DEL CONFLICTO ARMADO</label>
                                                <input
                                                    id='orgTotalintegrantevictima'
                                                    type="number"
                                                    min="0"
                                                    step="1"
                                                    {...register('orgTotalintegrantevictima', { valueAsNumber: true })}
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div id="divGruposPoblacion" className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='gruposPoblacionales'>GRUPOS POBLACIONALES CON LOS QUE TRABAJA LA ORGANIZACI&Oacute;N</label>
                                            <Select
                                                id="gruposPoblacionales"
                                                value={gruposPoblacionSelected}
                                                isMulti
                                                name="gruposPoblacionales"
                                                options={gruposPoblaciones}
                                                onChange={ActualizarGruposPoblacion}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                                styles={{
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999
                                                    })
                                                }}
                                            />
                                            {errors.gruposPoblacionales && <p style={{ color: 'red' }}>Seleccione campos</p>}
                                            </div>
                                        </div>
                                        <div id="divFuentesFinancieras" className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='fuentesFinancieras'>FUENTES DE FINANCIACI&Oacute;N</label>
                                            <Select
                                                id="fuentesFinancieras"
                                                value={fuentesFinancierasSelected}
                                                isMulti
                                                name="fuentesFinancieras"
                                                options={fuentesFinancieras}
                                                onChange={ActualizarFuenteFinancieras}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                            />
                                            {errors.fuentesFinancieras && <p style={{ color: 'red' }}>Seleccione campos</p>}
                                            </div>
                                        </div>  
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor='orgTematica'>TEM&Aacute;TICAS QUE ABORDA LA ORGANIZACI&Oacute;N</label>
                                            </div>
                                            <textarea
                                                id='orgTematica'
                                                {...register('orgTematica')}
                                                className="form-control"
                                                rows={4}
                                                placeholder="Describa las temáticas (múltiples líneas permitidas)"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor='orgTieneplantrabajo'>¿CUENTA CON PLAN DE TRABAJO?</label>
                                                <select id='orgTieneplantrabajo' {...register('orgTieneplantrabajo', {required: true})} className="form-control">
                                                    <option value=""></option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.orgTieneplantrabajo && <p style={{ color: 'red' }}>Seleccione una opción</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="orgFechaactualizacion">FECHA ACTUALIZACI&Oacute;N</label>
                                                <div style={{ marginTop: 6 }}>
                                                    <Controller
                                                        control={control}
                                                        name="orgFechaactualizacion"
                                                        rules={{ required: "Seleccione fecha actualizaci&oacute;n" }}
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 6, display: 'block', width: '100%' }}>
                                                                <DatePicker
                                                                    placeholderText="fecha actualizaci&oacute;n"
                                                                    onChange={(date) => field.onChange(date)}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value ? new Date(field.value) : null}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                    wrapperClassName="w-100"
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.orgFechaactualizacion && <p style={{color: 'red'}}>{errors.orgFechaactualizacion.message || 'Seleccione fecha actualizaci\u00f3n'}</p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label htmlFor='orgObservaciones'>Observaciones</label>
                                                <textarea id='orgObservaciones' {...register('orgObservaciones')} className="form-control" rows={3} />
                                            </div>
                                        </div>
                                    </div>
                                 </div>
                                <div className="card-footer">
                                     <button type="submit" className="btn btn-primary" style={{ marginRight: 8 }}>Guardar</button>
                                     <button
                                            type="button"
                                            className="btn btn-secondary"
                                            onClick={() => Navigate('/organizaciones/listar')}
                                            aria-label="Volver"
                                        >
                                            Volver
                                        </button>
                                 </div>
                                 
                            </form>
                        </div>

                        </div>
                        {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}